import { Component, OnInit } from '@angular/core';
import {MenuItem} from 'primeng/api';

@Component({
  selector: 'app-job-request-details',
  templateUrl: './job-request-details.component.html',
  styleUrls: ['./job-request-details.component.scss']
})
export class JobRequestDetailsComponent implements OnInit {
  events1: any[];
  displayBasic: boolean;
  displayBasic2: boolean;
  items: MenuItem[];
  constructor() { }

  ngOnInit(): void {
    this.items = [
      {label: 'Menu'},
      {label: 'Menu Active'},
  ];
  this.events1 = [
    {
      
      class: "step-completed",
      iconclass:"step-completed-icon"
    },
    {
      class: "step-next",
      iconclass:"step-next-icon"
    },
    {
      class: "step-pending",
      iconclass:"step-pending-icon"
    }
  ];
  }

  showBasicDialog() {
    this.displayBasic = true;
  }
  showBasicDialog2() {
    this.displayBasic2 = true;
  }

}
